import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": false
}
const addCustomCallData = createSlice({
    name:'addCustomCallData',
    initialState,
    reducers:{
        addCustomCallData: (_state,payload)=>{
            return {
                "id" : uuidv4(),
                "data": payload.payload
            }
        }
    }
});

export default addCustomCallData.reducer
export const addCustomCall = addCustomCallData.actions.addCustomCallData